import { flexRender, Row } from '@tanstack/react-table'
import { z } from 'zod'
import { useSortable } from '@dnd-kit/sortable'
import { TableCell, TableRow } from '@/components/ui/table'
import { CSS } from '@dnd-kit/utilities'
import * as React from 'react'
import { schema } from '@/pages/powerdoc-project-view'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export default function DraggableRow({ row }: { row: Row<z.infer<typeof schema>> }) {
  const { transform, transition, setNodeRef, isDragging } = useSortable({
    id: row.original.id,
  })

  return (
    <TableRow
      data-state={row.getIsSelected() && 'selected'}
      data-dragging={isDragging}
      ref={setNodeRef}
      className="relative z-0 data-[dragging=true]:z-10 data-[dragging=true]:opacity-80 !border-b-1 text-wrap flex-wrap"
      style={{
        transform: CSS.Transform.toString(transform),
        transition: transition,
      }}
    >
      {row.getVisibleCells().map((cell) => (
        <TableCell key={cell.id} className="text-wrap wrap">
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      ))}
    </TableRow>
  )
}
